import React, { useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function ExcelExportScrap({ JsonData }) {
  if (JsonData?.length === 0) {
    return (
      <Button
        variant="contained"
        fullWidth
        color="secondary"
        endIcon={<CloudDownloadIcon />}
      >
        Excel
      </Button>
    );
  }

  const handleExport = () => {
    const ExportData = JsonData.map((item) => ({
      FIS_NO: item.FIS_NO,
      TEKNISYEN: item.TEKNISYEN,
      DURUM: item.DURUM,
      KUL_MODEL_KODU: item.KUL_MODEL_KODU,
      MALZEME_STOK_NO: item.MALZEME_STOK_NO,
      MALZEME: item.MALZEME,
      MALZEME_ESKISI_DURUM: item.HURDA_DURUM,
      KRITIK: item.KRITIK,
      ADET: item.ADET,
      BARKOD_OKUTMA_DURUM: item.BARKOD_OKUTMA_DURUM,
      BARKOD_OKUTMA_EKRAN_DURUM: item.BARKOD_OKUTMA_EKRAN_DURUM,
      ARAC_TAKIP_NO: item.ARAC_TAKIP_NO,
    }));

    // Header dizisi
    const headers = [
      { label: 'FişNo', value: 'FIS_NO' },
      { label: 'Teknisyen', value: 'TEKNISYEN' },
      { label: 'Durum', value: 'DURUM' },
      { label: 'ModelKodu', value: 'KUL_MODEL_KODU' },
      { label: 'MalzemeStokNo', value: 'MALZEME_STOK_NO' },
      { label: 'Malzeme', value: 'MALZEME' },
      { label: 'MalzemeEskisiDurum', value: 'MALZEME_ESKISI_DURUM' },
      { label: 'Kritik', value: 'KRITIK' },
      { label: 'Adet', value: 'ADET' },
      { label: 'BarkodBasım', value: 'BARKOD_OKUTMA_DURUM' },
      { label: 'BarkodOkutma', value: 'BARKOD_OKUTMA_EKRAN_DURUM' },
      { label: 'AraçTeslimNo', value: 'ARAC_TAKIP_NO' },
    ];

    // Başlıkları ve veriyi işleyip sheet oluşturma
    const sheetData = [
      headers.map(header => header.label),
      ...ExportData.map(item => headers.map(header => item[header.value])),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

    // Excel dosyasını indirme
    XLSX.writeFile(workbook, 'Envanter.xlsx');
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleExport}
      endIcon={<CloudDownloadIcon />}
    >
      Excel
    </Button>
  );
}

export default ExcelExportScrap;
